// extracted by mini-css-extract-plugin
export default {"avatar":"CzpdOdPsJZD7z7deTZ_g","avatars":"ufi0l5XPeN0LvpXSZWAl"};